import { Grid, Paper, Tab, Tabs } from '@mui/material';
import React from 'react';

interface EntriesTabsProps {
  activeTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  totalValidEntries: number;
  totalInvalidEntries: number;
}

const EntriesTabs: React.FC<EntriesTabsProps> = ({
  activeTab,
  onTabChange,
  totalValidEntries,
  totalInvalidEntries,
}) => {
  if (totalValidEntries === 0 && totalInvalidEntries === 0) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={onTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          {totalValidEntries > 0 && (
            <Tab label={`Asientos Válidos (${totalValidEntries})`} value={0} />
          )}
          {totalInvalidEntries > 0 && (
            <Tab
              label={`Asientos con Errores (${totalInvalidEntries})`}
              value={1}
            />
          )}
        </Tabs>
      </Paper>
    </Grid>
  );
};

export default EntriesTabs;
